// Single owner of the `card:` / `column:` prefixes that namespace dnd-kit drag
// ids.
//
// Every draggable and droppable inside one DndContext needs a unique id, but
// cards and columns come from the server with independent id spaces that can
// collide. Prefixing by type keeps them apart. Encoding and decoding live
// together here so the two halves can never drift — previously the prefixes
// were built with inline template literals in four components and stripped
// with three different techniques (regex, slice, startsWith) across a dozen
// call sites.

const CARD = 'card:';
const COLUMN = 'column:';

export const cardDragId = (cardId: string) => `${CARD}${cardId}`;
export const columnDragId = (columnId: string) => `${COLUMN}${columnId}`;

export const isCardDragId = (dragId: string | number) =>
  String(dragId).startsWith(CARD);
export const isColumnDragId = (dragId: string | number) =>
  String(dragId).startsWith(COLUMN);

/** Strips the `card:` prefix. Returns the input unchanged if not prefixed. */
export const cardIdOf = (dragId: string | number) => {
  const id = String(dragId);
  return id.startsWith(CARD) ? id.slice(CARD.length) : id;
};

/** Strips the `column:` prefix. Returns the input unchanged if not prefixed. */
export const columnIdOf = (dragId: string | number) => {
  const id = String(dragId);
  return id.startsWith(COLUMN) ? id.slice(COLUMN.length) : id;
};
